import { useContext } from "react";

import ClinicCompatibleAuthContext from "../contexts/ClinicCompatibleAuthContext.js";

export function useClinicCompatibleAuth() {
  return useContext(ClinicCompatibleAuthContext);
}
